/**
 * Document scroll after a full route change.
 *
 * Marketing nav (hamburger, footer, header links) must land at the TOP of the
 * new page. Browser Back / Forward must also land at the TOP of the previous
 * page — not the old scroll offset, footer, or a leftover modal overlay.
 *
 * Hash / fragment identifiers are left alone so in-page anchors still work.
 */

export const isLandingPath = pathname => {
  if (typeof pathname !== 'string') {
    return false;
  }
  return pathname === '/' || pathname === '';
};

export const disableNativeScrollRestoration = () => {
  if (typeof window === 'undefined' || !window.history || !('scrollRestoration' in window.history)) {
    return;
  }
  try {
    window.history.scrollRestoration = 'manual';
  } catch (e) {
    // Ignore.
  }
};

const applyTop = () => {
  if (typeof window === 'undefined') {
    return;
  }
  window.scrollTo(0, 0);
};

/**
 * Jump the document to (0, 0). Immediate plus a paint later so a closing
 * modal or leftover restore cannot leave the user mid-page.
 */
export const scrollDocumentToTop = () => {
  if (typeof window === 'undefined') {
    return;
  }
  applyTop();
  if (typeof window.requestAnimationFrame === 'function') {
    window.requestAnimationFrame(() => {
      applyTop();
    });
  }
  if (typeof window.setTimeout === 'function') {
    window.setTimeout(applyTop, 0);
  }
};

/**
 * Used by the router on location change (push, replace, and pop/Back).
 * @returns {boolean} true if this function handled scrolling (no hash)
 */
export const handleRouteDocumentScroll = location => {
  if (typeof window === 'undefined' || !location) {
    return false;
  }
  if (location.hash) {
    return false;
  }
  scrollDocumentToTop();
  return true;
};

/**
 * @deprecated Use handleRouteDocumentScroll. Kept so older imports still
 * scroll to top instead of restoring a saved homepage offset.
 */
export const handleLandingRouteScroll = handleRouteDocumentScroll;
